import ApiService from './api'

export default {
  getCategories() {
    return ApiService.get('/categories', null, null)
  },
}
